export enum PluginTypeEnum {
  UPLOAD_HUB,
}
